import { useCallback } from "react";
import { NavigateOptions, useNavigate as useNavigate_, useSearchParams } from "react-router-dom";
import { Path, parsePath } from "history";

type Options = { queryParams?: URLSearchParams, preserveQueryParams: boolean, options?: any };
export function useNavigate() {
  const navigate = useNavigate_();
  const [existingQueryParams] = useSearchParams();
  return useCallback((to: string | Partial<Path>, options: Options = { preserveQueryParams: true }) => {
    if (!options.queryParams) {
      options.queryParams = new URLSearchParams();
    }

    if (options.preserveQueryParams) {
      existingQueryParams.forEach((value, key) => options.queryParams?.set(key, value));
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    to = typeof to === "string" ? parsePath(to) : to;
    if (to?.search) {
      new URLSearchParams(to.search).forEach((value, key) => options.queryParams?.set(key, value));
    }
    navigate({ ...to, search: options.queryParams.toString() }, options as NavigateOptions);
    window.scrollTo(0, 0);
  }, [navigate, existingQueryParams]);
}
